import React from 'react';
import { bool, string } from 'prop-types';

import Theme from '../../../styles-and-themes/themes/theme';
import MLIcon from '../MLIcon/MLIcon';
import { PasswordChecksV2, RequirementsContainerV2 } from './PasswordValidationV2Styles';

const PasswordValidationV2 = (props) => {
  const reqs = [
    {
      id: 'pwvalidator-length',
      isValid: props.eight,
      label: '8 - 72 characters',
    },
    {
      id: 'pwvalidator-upper',
      isValid: props.upper,
      label: 'Uppercase Letter',
    },
    {
      id: 'pwvalidator-special',
      isValid: props.special,
      label: 'Special Character',
    },
    {
      id: 'pwvalidator-number',
      isValid: props.number,
      label: 'Number',
    },
    {
      id: 'pwvalidator-lower',
      isValid: props.lower,
      label: 'Lowercase Letter',
    },
  ];

  return (
    <PasswordChecksV2 id={props.id}>
      <RequirementsContainerV2>
        {
          reqs.map(({ isValid, label, id }) => (
            <div
              style={{ color: isValid ? Theme.very_dark_gray : Theme.dark_gray }}
              key={`requirements-container-${id}`}
            >
              <MLIcon
                type={isValid ? 'circle_check_outline' : 'circle'}
                style={{ fill: isValid ? 'rgb(3, 0, 165)' : Theme.dark_gray }}
                title={`requirement ${isValid ? '' : 'not '}met, ${label}`}
                aria-hidden={isValid}
              />
              <span
                aria-hidden
              >
                {label}
              </span>
            </div>
          ))
        }
      </RequirementsContainerV2>
    </PasswordChecksV2>
  );
};

PasswordValidationV2.propTypes = {
  id: string, // TODO: Make this required after v1 UI elimination
  eight: bool.isRequired,
  upper: bool.isRequired,
  lower: bool.isRequired,
  number: bool.isRequired,
  special: bool.isRequired,
};

PasswordValidationV2.defaultProps = {
  id: 'passwordChecks', // TODO: Deprecate this after v1 UI elimination
};

export default PasswordValidationV2;
